import { useAutoAnimate } from "@formkit/auto-animate/react"
import { DeleteCouponButton } from "src/components/checkout/DeleteCouponButton"
import { useCoupons } from "src/components/checkout/hooks/useCoupon"
import { CouponCode } from "src/components/generic/CouponCode"

export const CouponLines = () => {
  const { codes } = useCoupons()
  const [animationParent] = useAutoAnimate()

  if (!codes?.length) {
    return null
  }

  return (
    <div ref={animationParent}>
      {codes
        .sort((a, b) => a.localeCompare(b))
        .map((code) => {
          return (
            <div className="flex h-6 items-center gap-2" key={code}>
              <div className="text-np-green">Rabattcode</div>
              <CouponCode>{code}</CouponCode>
              <DeleteCouponButton code={code} />
            </div>
          )
        })}
    </div>
  )
}
